var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-database" },
    _vm._l(_vm.tabList, function (tab) {
      return _c("div", { key: tab.name, staticClass: "db-item" }, [
        _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(tab.title))]),
        _c(
          "ul",
          { staticClass: "item-content" },
          _vm._l(tab.tabItems, function (it) {
            return _c(
              "li",
              {
                key: it.name,
                on: {
                  click: function ($event) {
                    return _vm.openUrl(it.urlAddress)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "img-wrap" },
                  [
                    _c("dsfImage", {
                      attrs: { src: it.imgUrl, dUrl: it.imgUrl },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "name" }, [_vm._v(_vm._s(it.name))]),
              ]
            )
          }),
          0
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }